import * as React from 'react';
import { useIntl } from 'react-intl';
import Modal from 'react-modal';

import ErrorReporter from 'app/components/ErrorReporter';
import DeliveryModalContainer from 'chat/components/DeliveryModal/DeliveryModalContainer';
import ReactionSummaryModal from 'chat/components/ReactionSummaryModal';
import Button from 'components/Button';
import Icon from 'components/Icon';

export type MessageActionsModal = '' | 'delivery' | 'reactions';

export type Props = {
  canViewDeliveryInformation: boolean;
  messageUuid: string;
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'ReactionGQL'.
  reactions?: ReactionGQL[] | null;
  streamUuid: string;
  targetDescription?: string | null;
  targetTitle: string;
};

const InfoButton: React.FC<Props> = ({
  canViewDeliveryInformation,
  messageUuid,
  reactions,
  streamUuid,
  targetDescription,
  targetTitle,
}) => {
  const { formatMessage } = useIntl();
  const [modal, setModal] = React.useState<MessageActionsModal>('');
  const handleRequestHide = () => {
    setModal('');
  };

  const renderDeliveryModal = () => {
    if (!streamUuid) {
      return (
        <ErrorReporter error="AnnouncementMessageItemHeader - tried to render delivery summary link without streamUuid" />
      );
    } else if (!messageUuid) {
      return (
        <ErrorReporter error="AnnouncementMessageItemHeader - tried to render delivery summary link without messageUuid" />
      );
    }

    return (
      <DeliveryModalContainer
        source={{
          type: 'stream',
          threadUuid: streamUuid,
          messageUuid,
          targetTitle: targetTitle,
          targetDescription: targetDescription,
        }}
        onRequestHide={handleRequestHide}
      />
    );
  };

  const renderReactionsModal = () => {
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ reactions: ReactionGQL[]; onRequestHide: (... Remove this comment to see the full error message
    return <ReactionSummaryModal reactions={reactions} onRequestHide={handleRequestHide} />;
  };

  const renderModal = () => {
    if (modal === 'delivery') {
      return renderDeliveryModal();
    } else if (modal === 'reactions') {
      return renderReactionsModal();
    }
  };

  return (
    <React.Fragment>
      <Modal isOpen={!!modal}>{renderModal()}</Modal>
      <Button
        aria-label={formatMessage({
          id: canViewDeliveryInformation
            ? 'messages.buttons.displayDeliverySummary'
            : 'messages.buttons.displayReactionsSummary',
        })}
        eventKey={
          canViewDeliveryInformation
            ? 'message_cell.delivery_summary.click'
            : 'message_cell.reaction_summary.click'
        }
        onClick={() => (canViewDeliveryInformation ? setModal('delivery') : setModal('reactions'))}
        size="small"
      >
        <Icon name="info-circle" />
      </Button>
    </React.Fragment>
  );
};

export default InfoButton;
